export default __webpack_public_path__ + "static/media/line-background.92301f62.svg";